import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import "./contact.css";
import { SlEnvolope } from "react-icons/sl";
import { MdAddCall } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";

export default function Contect() {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_3qps9kq', 'template_kqdic49', form.current, {
        publicKey: 'wEXcKtBjJTcKYVfkS',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };

    return(
        <div id="Contact" className="contect">
            <div className="contectTitle">
                <h1>Get In Touch</h1>
                <img src="/images/back.png" alt="" />
            </div>
            <div className="contectSection">
                <div className="contectLeft">
                    <h1>Let's talk</h1>
                    <p>I'mcurrently available to talk onnew projects,so feel free to send me a message about anything that you want me to work on.you can contact anytime.</p>
                    <div className="contactDetails">
                        <div className="contectDetail">
                            <SlEnvolope/>
                            <p>sk.roshansameers.h.k@gmail.com</p>
                        </div>
                        <div className="contectDetail">
                            <MdAddCall/>
                            <p>8977681686</p>
                        </div>
                        <div className="contectDetail">
                            <FaLocationDot/>
                            <p>chittor,Andhara Pradesh,India</p>
                        </div>
                    </div>
                </div>
                <form ref={form} className="contactRight" onSubmit={sendEmail}>
                    <label htmlFor="">Your Name</label>
                    <input type="text" placeholder="enter your name" name="user_name" />
                    <label htmlFor="">Your Email</label>
                    <input type="text" placeholder="enter your Email" name="user_email" />
                    <label htmlFor="">Write your message here</label>
                    <textarea name="message" rows="8" placeholder="enter your message"></textarea>
                    <button className="contactSubmit">Submit now</button>
                </form>

            </div>
        </div>
    )
}